import { SendOutlined, DownloadOutlined, SaveOutlined, SearchOutlined, EditOutlined, LockOutlined, ArrowLeftOutlined, DeleteOutlined, UploadOutlined, InboxOutlined, FileExcelOutlined } from '@ant-design/icons';
import { Button, Col, Input, Row, Space, Tabs, Form, Select, Checkbox, DatePicker, Modal, Table } from 'antd';
import Dropzone from 'react-dropzone';
import dayjs, { Dayjs } from 'dayjs';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { ContentHeader } from '../../components';
import ModalTextForm from '../../components/modal/ModalTextForm';
import { dateCommon, formatVND, validateMessages } from '../../helpers/common';
import { ChiTietLuongCoBanItem, DanhMucHeSoLuongThieuItem, LuongCoBanInfo } from '../../models/luong/LuongCoBanModel';
import { BaoHiem } from '../../models/baohiem/BaoHiem';
import { DanhSachKhenThuongUngHoResponse } from '../../models/luong/Luong';
import TableChiTietLuongCoBan from '../../modules/salary/TableChiTietLuongCoBan';
import { duyetLuongCoBan, layChiTietLuongCoBan, layThongTinLuongCoBan, luuLuongCoBan, taiLuongCoBan, capNhatDuLieuThamChieuLuongCoBan, layDsKhenThuongUngHoTheoNam, layDsLuongCoBanTamUngTheoNam, luuDieuChinhChiTietLuong, xoaBangLuongCoBan, xuatExcelLuongCoBan, importFileLuongCoBan } from '../../services/luong';
import { layDsBaoHiemTheoNam } from '../../services/baohiem';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import { Link, useNavigate } from 'react-router-dom';
import { Links } from '../../helpers/Links';

const ChiTietLuongCoBan = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [form] = Form.useForm();

    const [idLuongCoBan, setIdLuongCoBan] = useState<number>(0);
    const [luongCoBan, setLuongCoBan] = useState<LuongCoBanInfo | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [tuKhoa, setTuKhoa] = useState<string>('');
    const [isShowModalDuyet, setIsShowModalDuyet] = useState<boolean>(false);
    const [isShowModalCapNhatThamChieu, setIsShowModalCapNhatThamChieu] = useState<boolean>(false);
    const [isShowModalXoa, setIsShowModalXoa] = useState<boolean>(false);
    const [isShowImportModal, setIsShowImportModal] = useState<boolean>(false);
    const [fileUpload, setFileUpload] = useState<File | null>(null);
    const [isShowModalThieuDanhMuc, setIsShowModalThieuDanhMuc] = useState<boolean>(false);
    const [dsDanhMucThieu, setDsDanhMucThieu] = useState<DanhMucHeSoLuongThieuItem[]>([]);
    const [ghiChu, setGhiChu] = useState<string>('');

    const [danhSachNLD, setDanhSachNLD] = useState<ChiTietLuongCoBanItem[]>([]);
    const [danhSachChiTiet, setDanhSachChiTiet] = useState<ChiTietLuongCoBanItem[]>([]);

    const [reload, setReload] = useState<boolean>(false);

    // State cho modal cập nhật tham chiếu
    const [dsBaoHiem, setDsBaoHiem] = useState<Array<BaoHiem>>([]);
    const [dsKhenThuongUngHo, setDsKhenThuongUngHo] = useState<Array<DanhSachKhenThuongUngHoResponse>>([]);
    const [namLocBaoHiem, setNamLocBaoHiem] = useState<Dayjs | null>(null);
    const [namLocKhenThuong, setNamLocKhenThuong] = useState<Dayjs | null>(null);
    const [namLocTamUng, setNamLocTamUng] = useState<Dayjs | null>(null);
    const [dsTamUng, setDsTamUng] = useState<any[]>([]);

    // State cho chế độ điều chỉnh
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [changedRowIds, setChangedRowIds] = useState<Set<number>>(new Set());

    const setChiTiet = (data: ChiTietLuongCoBanItem[]) => {
        setDanhSachChiTiet(data);
        setDanhSachNLD(data);
    };

    const layThongTin = async (id: number) => {
        dispatch(showLoadingScreen());
        try {
            const info = await layThongTinLuongCoBan(id);
            setLuongCoBan(info);
            setGhiChu(info?.ghiChu ?? '');
            const chiTiet = await layChiTietLuongCoBan(id);
            setChiTiet(chiTiet ?? []);
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
        dispatch(hideLoadingScreen());
    };

    const handleTinhLuong = async () => {
        dispatch(showLoadingScreen());
        try {
            const data = await taiLuongCoBan(idLuongCoBan);
            setChiTiet(data ?? []);
            toast.success('Tính lương cơ bản thành công');
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
        dispatch(hideLoadingScreen());
    };

    const handleImportExcel = async (xacNhanTaoDanhMuc: boolean = false) => {
        if (!fileUpload) {
            toast.warning('Vui lòng chọn file Excel để import');
            return;
        }
        dispatch(showLoadingScreen());
        try {
            const rs = await importFileLuongCoBan(idLuongCoBan, fileUpload, xacNhanTaoDanhMuc);
            if (rs?.canXacNhanDanhMuc && (rs?.dsDanhMucThieu?.length ?? 0) > 0) {
                setDsDanhMucThieu(rs.dsDanhMucThieu);
                setIsShowImportModal(false);
                setIsShowModalThieuDanhMuc(true);
            } else {
                setChiTiet(rs?.chiTiet ?? []);
                setIsShowImportModal(false);
                setIsShowModalThieuDanhMuc(false);
                setDsDanhMucThieu([]);
                setFileUpload(null);
                toast.success('Import lương cơ bản thành công');
            }
        } catch (e: any) {
            toast.error(e?.message || e?.toString().replace('Error: ', '') || 'Import lương cơ bản không thành công');
        }
        dispatch(hideLoadingScreen());
    };

    const handleLuu = async () => {
        dispatch(showLoadingScreen());
        try {
            await luuLuongCoBan({ id: idLuongCoBan, ghiChu, chiTiet: danhSachChiTiet });
            toast.success('Lưu lương cơ bản thành công');
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
        dispatch(hideLoadingScreen());
    };

    const handleDuyet = async () => {
        dispatch(showLoadingScreen());
        try {
            await duyetLuongCoBan(idLuongCoBan);
            toast.success('Xác nhận lương cơ bản thành công');
            setIsShowModalDuyet(false);
            setReload(true);
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
        dispatch(hideLoadingScreen());
    };

    const handleXoa = async () => {
        dispatch(showLoadingScreen());
        try {
            await xoaBangLuongCoBan(idLuongCoBan);
            toast.success('Xóa bảng lương cơ bản thành công');
            navigate(Links.Luong.DanhSachLuongCoBan);
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
        dispatch(hideLoadingScreen());
    };

    const handleExportExcel = async () => {
        if (!idLuongCoBan || idLuongCoBan <= 0) {
            toast.warning('Không tìm thấy thông tin lương cơ bản');
            return;
        }
        dispatch(showLoadingScreen());
        try {
            const response = await xuatExcelLuongCoBan(idLuongCoBan);
            const fileName = `${luongCoBan?.tenKyLuong || 'BangLuongCoBan'}.xlsx`;
            const link = document.createElement('a');
            link.download = fileName;
            const blob = new Blob([response.data], { type: response.data.type });
            link.href = URL.createObjectURL(blob);
            link.click();
            URL.revokeObjectURL(link.href);
        } catch (err: any) {
            toast.error('Xuất file Excel không thành công. Vui lòng thử lại');
        } finally {
            dispatch(hideLoadingScreen());
        }
    };

    // Xử lý thay đổi giá trị tại 1 ô trong bảng khi đang chế độ điều chỉnh
    const onChangeItem = (index: number, field: string, newValue: number) => {
        const updatedList = [...danhSachNLD];
        const row = { ...updatedList[index] };
        const isDieuChinh = luongCoBan?.loai === 0;

        if (field === 'soCong') {
            const oldSoCong = row.soCong ?? 0;
            if (oldSoCong !== 0) {
                // Tính lại tiền lương tạm ứng (chỉ với tạm ứng)
                if (!isDieuChinh) {
                    console.log(row.mucLuongHopDong, row?.soCong, newValue);
                    row.tienLuongTamUng = Math.round((row.mucLuongHopDong ?? 0) / (row!.congThang ?? 22) * newValue);
                    row.luongDuocNhan = row.tienLuongTamUng - (row.tongGiamTru ?? 0) + (row.luongKhac ?? 0);
                }
                else {
                    row.luongDuocNhan = Math.round((row.mucLuongHopDong ?? 0) / (row!.congThang ?? 22) * newValue) - (row.tongGiamTru ?? 0) + (row.luongKhac ?? 0);
                }
            }
            row.soCong = newValue;
            row.luongCBThucNhan = (row.luongDuocNhan ?? 0) - (row.luongDaNhan ?? 0);
        } else if (field === 'tienLuongTamUng') {
            const oldTienTamUng = row.tienLuongTamUng ?? 0;
            const diff = newValue - oldTienTamUng;
            row.tienLuongTamUng = newValue;
            row.luongDuocNhan = (row.luongDuocNhan ?? 0) + diff;
            row.luongCBThucNhan = (row.luongDuocNhan ?? 0) - (row.luongDaNhan ?? 0);
        } else if (field === 'congDoan') {
            const oldCongDoan = row.congDoan ?? 0;
            const diff = newValue - oldCongDoan;
            row.congDoan = newValue;
            row.tongGiamTru = (row.tongGiamTru ?? 0) + diff;
            row.luongDuocNhan = (row.luongDuocNhan ?? 0) - diff;
            row.luongCBThucNhan = (row.luongDuocNhan ?? 0) - (row.luongDaNhan ?? 0);
        } else if (field === 'luongDuocNhan') {
            row.luongDuocNhan = newValue;
            row.luongCBThucNhan = newValue - (row.luongDaNhan ?? 0);
        }

        updatedList[index] = row;
        setDanhSachNLD(updatedList);

        // Cập nhật cả danhSachChiTiet
        const fullList = [...danhSachChiTiet];
        const chiTietIndex = fullList.findIndex(x => x.id === row.id);
        if (chiTietIndex >= 0) {
            fullList[chiTietIndex] = row;
            setDanhSachChiTiet(fullList);
        }

        // Track changed row
        setChangedRowIds(prev => {
            const newSet = new Set(prev);
            newSet.add(row.id);
            return newSet;
        });
    };

    // Lưu điều chỉnh chỉ gửi các row đã thay đổi
    const handleLuuDieuChinh = async () => {
        if (changedRowIds.size === 0) {
            toast.warning('Không có dữ liệu thay đổi!');
            return;
        }

        dispatch(showLoadingScreen());
        try {
            const changedItems = danhSachChiTiet
                .filter(x => changedRowIds.has(x.id))
                .map(x => ({
                    id: x.id,
                    soCong: x.soCong ?? 0,
                    tienLuongTamUng: x.tienLuongTamUng ?? 0,
                    congDoan: x.congDoan ?? 0,
                    tongGiamTru: x.tongGiamTru ?? 0,
                    luongDuocNhan: x.luongDuocNhan ?? 0,
                    luongCBThucNhan: x.luongCBThucNhan ?? 0,
                }));

            await luuDieuChinhChiTietLuong({ items: changedItems });
            toast.success(`Lưu điều chỉnh thành công (${changedItems.length} dòng)`);
            setChangedRowIds(new Set());
            setIsEdit(false);
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
        dispatch(hideLoadingScreen());
    };

    const layDsBaoHiemModal = async (nam?: number) => {
        try {
            const bh = await layDsBaoHiemTheoNam(nam);
            setDsBaoHiem(bh ?? []);
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
    };

    const layDsKhenThuongUngHoModal = async (nam?: number) => {
        try {
            const ktuh = await layDsKhenThuongUngHoTheoNam(nam);
            setDsKhenThuongUngHo(ktuh ?? []);
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
    };

    const layDsTamUngModal = async (nam?: number) => {
        try {
            const tamung = await layDsLuongCoBanTamUngTheoNam(nam);
            setDsTamUng(tamung ?? []);
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
    };

    const onMoModalCapNhatThamChieu = async () => {
        // Nếu có dữ liệu khen thưởng/ủng hộ hiện tại, set namLocKhenThuong = null để bắt buộc chọn năm
        let initialNameLocKhenThuong: Dayjs | null = null;
        if (!luongCoBan?.dsIdLuongKhenThuongUngHo || (luongCoBan?.dsIdLuongKhenThuongUngHo?.length ?? 0) === 0) {
            initialNameLocKhenThuong = dayjs().year(dayjs().year());
        }

        const namHienTai = dayjs().year();
        setNamLocBaoHiem(dayjs().year(namHienTai));
        setNamLocKhenThuong(initialNameLocKhenThuong);

        // Tính toán năm tạm ứng initial (nếu là loại 0 - điều chỉnh)
        let initialNamLocTamUng: Dayjs | null = null;
        if (luongCoBan?.loai === 0) {
            initialNamLocTamUng = dayjs().year(dayjs().year());
            setNamLocTamUng(initialNamLocTamUng);
        }

        // Set giá trị hiện tại vào form
        form.setFieldsValue({
            isTruCongDoan: luongCoBan?.isTruCongDoan ?? false,
            dsIdBaoHiemThang: luongCoBan?.dsIdBaoHiemThang ?? [],
            dsIdLuongKhenThuongUngHo: luongCoBan?.dsIdLuongKhenThuongUngHo ?? [],
            idLuongTamUng: luongCoBan?.idLuongTamUng,
        });

        const promises: Promise<void>[] = [
            layDsBaoHiemModal(namHienTai),
            layDsKhenThuongUngHoModal(initialNameLocKhenThuong ? initialNameLocKhenThuong.year() : undefined),
        ];

        if (luongCoBan?.loai === 0) {
            promises.push(layDsTamUngModal(initialNamLocTamUng ? initialNamLocTamUng.year() : undefined));
        }

        await Promise.all(promises);
        setIsShowModalCapNhatThamChieu(true);
    };

    const onChangeNamLocBaoHiem = async (date: Dayjs | null) => {
        setNamLocBaoHiem(date);
        form.setFieldsValue({ dsIdBaoHiemThang: [] });
        await layDsBaoHiemModal(date ? date.year() : undefined);
    };

    const onChangeNamLocKhenThuong = async (date: Dayjs | null) => {
        setNamLocKhenThuong(date);
        form.setFieldsValue({ dsIdLuongKhenThuongUngHo: [] });
        await layDsKhenThuongUngHoModal(date ? date.year() : undefined);
    };

    const onChangeNamLocTamUng = async (date: Dayjs | null) => {
        setNamLocTamUng(date);
        form.setFieldsValue({ idLuongTamUng: undefined });
        await layDsTamUngModal(date ? date.year() : undefined);
    };

    const onFinishCapNhatThamChieu = async (values: any) => {
        dispatch(showLoadingScreen());
        try {
            const request = {
                id: idLuongCoBan,
                isTruCongDoan: !!values?.isTruCongDoan,
                idLuongTamUng: values?.idLuongTamUng ? parseInt(values.idLuongTamUng) : null,
                dsIdBaoHiemThang: (values?.dsIdBaoHiemThang ?? []) as number[],
                dsIdLuongKhenThuongUngHo: (values?.dsIdLuongKhenThuongUngHo ?? []) as number[],
            };
            await capNhatDuLieuThamChieuLuongCoBan(request);
            toast.success('Cập nhật dữ liệu tham chiếu thành công!');
            setIsShowModalCapNhatThamChieu(false);

            // Refresh dữ liệu
            await layThongTin(idLuongCoBan);

            // Tính lại lương
            await handleTinhLuong();
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
        dispatch(hideLoadingScreen());
    };

    const search = () => {
        const kw = (tuKhoa || '').toLowerCase();
        setDanhSachNLD(
            danhSachChiTiet.filter(
                (x) =>
                    kw.length === 0 ||
                    (x.hoTen ?? '').toLowerCase().includes(kw) ||
                    (x.ma ?? '').toLowerCase().includes(kw)
            )
        );
    };

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const id = parseInt(params.get('id') || '0');
        if (id > 0) {
            setIdLuongCoBan(id);
        }
    }, []);

    useEffect(() => {
        if (idLuongCoBan > 0) {
            layThongTin(idLuongCoBan);
        }
    }, [idLuongCoBan]);

    useEffect(() => {
        if (reload && idLuongCoBan > 0) {
            setReload(false);
            layThongTin(idLuongCoBan);
        }
    }, [reload]);

    const isDaDuyet = (luongCoBan?.trangThai ?? 0) === 1;
    // Chỉ cho điều chỉnh khi dữ liệu đã được lưu (không phải từ việc tải dữ liệu lương), và chưa duyệt
    const coDuLieuDaLuu = danhSachChiTiet.length > 0 && danhSachChiTiet.some(x => x.id > 0);
    const coTheDieuChinh = !isDaDuyet && coDuLieuDaLuu;

    // Tính tổng mức lương đóng BHXH/HĐLĐ: nếu cùng 1 idNhanVien có nhiều row thì lấy số tiền lớn hơn
    const maxMucLuongByNhanVien = new Map<number, number>();
    let unnamedMucLuong = 0;
    (danhSachChiTiet ?? []).forEach(item => {
        const id = item.idNhanVien;
        const val = item.mucLuongHopDong ?? 0;
        if (id) {
            const cur = maxMucLuongByNhanVien.get(id) ?? 0;
            if (val > cur) {
                maxMucLuongByNhanVien.set(id, val);
            }
        } else {
            unnamedMucLuong += val;
        }
    });
    let tongMucLuong = unnamedMucLuong;
    maxMucLuongByNhanVien.forEach(val => {
        tongMucLuong += val;
    });

    // Các cột còn lại tính tổng bình thường trên tất cả các row
    const tongTienTamUng = (danhSachChiTiet ?? []).reduce((s, x) => s + (x.tienLuongTamUng ?? 0), 0);
    const tongThucNhan = (danhSachChiTiet ?? []).reduce((s, x) => s + (x.luongCBThucNhan ?? 0), 0);
    const tongLuongDaNhan = (danhSachChiTiet ?? []).reduce((s, x) => s + (x.luongDaNhan ?? 0), 0);

    return (
        <section>
            <ContentHeader
                title={luongCoBan?.tenKyLuong ?? ""}
            />

            <Row className="form-group" gutter={8}>
                <Col xs={22} sm={14} md={8}>
                    <Input
                        prefix={<SearchOutlined />}
                            placeholder="Nhập tên, mã nhân viên"
                            value={tuKhoa}
                            onChange={(e) => setTuKhoa(e.target.value)}
                            onKeyPress={(e) => { if (e.key === 'Enter') search(); }}
                    />
                </Col>
                <Col xs={2} sm={2} md={0}>
                    <Button type="primary" icon={<SearchOutlined />} onClick={search} />
                </Col>
                <Col xs={0} sm={0} md={4}>
                    <Button type="primary" icon={<SearchOutlined />} onClick={search}>
                        Tìm kiếm
                    </Button>
                </Col>
                <Col xs={24} sm={24} md={12}>
                    <Space className="float-right">
                        <Button type="default" icon={<ArrowLeftOutlined />} onClick={() => { navigate(Links.Luong.DanhSachLuongCoBan) } }>
                            Quay lại
                        </Button>
                        {!isDaDuyet && (
                            <Button
                                danger
                                type="primary"
                                icon={<DeleteOutlined />}
                                onClick={() => setIsShowModalXoa(true)}
                            >
                                Xóa dữ liệu
                            </Button>
                        )}
                        {!isDaDuyet && (
                            <Button
                                type="primary"
                                icon={<DownloadOutlined />}
                                onClick={handleTinhLuong}
                            >
                                Tính lương
                            </Button>
                        )}
                        {!isDaDuyet && (
                            <Button
                                className="hrm-btn hrm-btn-primary"
                                icon={<UploadOutlined />}
                                onClick={() => {
                                    setFileUpload(null);
                                    setIsShowImportModal(true);
                                }}
                            >
                                Import excel
                            </Button>
                        )}
                        {!isDaDuyet && (
                            <Button
                                type="primary"
                                icon={<SendOutlined />}
                                onClick={() => setIsShowModalDuyet(true)}
                            >
                                Xác nhận
                            </Button>
                        )}
                        {!isDaDuyet && (
                            <Button
                                className="hrm-btn hrm-btn-warning"
                                icon={<SaveOutlined />}
                                onClick={handleLuu}
                            >
                                Lưu
                            </Button>
                        )}
                        <Button
                            className="hrm-btn hrm-btn-success"
                            icon={<DownloadOutlined />}
                            onClick={handleExportExcel}
                        >
                            Xuất Excel
                        </Button>
                    </Space>
                </Col>
            </Row>

            <Row gutter={8} className="form-group">
                <Col xs={24} sm={24} md={24}>
                    <div className="card card-primary" style={{ padding: '15px' }}>
                        <div style={{ marginBottom: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div style={{ fontSize: '14px', fontWeight: 'bold' }}>Dữ liệu tham chiếu</div>
                            {!isDaDuyet && (
                                <Button
                                    type="primary"
                                    size="small"
                                    icon={<EditOutlined />}
                                    onClick={onMoModalCapNhatThamChieu}
                                >
                                    Cập nhật
                                </Button>
                            )}
                        </div>
                        <Row gutter={[16, 16]}>
                            {luongCoBan?.loai !== 1 && (
                                <Col xs={24} sm={12} md={6}>
                                    <div style={{ fontSize: '12px', color: '#666' }}>Kỳ lương tạm ứng</div>
                                    <div style={{ fontSize: '13px', marginTop: '5px' }}>
                                        {luongCoBan?.idLuongTamUng != undefined && luongCoBan?.idLuongTamUng > 0
                                            ? <Link to={Links.Luong.ChiTietLuongCoBan + "?id=" + luongCoBan?.idLuongTamUng} target="_blank">{luongCoBan?.tenKyLuongTamUng}</Link>
                                            : 'Không có'}
                                    </div>
                                </Col>
                            )}
                            <Col xs={24} sm={12} md={luongCoBan?.loai === 1 ? 8 : 6}>
                                <div style={{ fontSize: '12px', color: '#666' }}>Bảo hiểm áp dụng</div>
                                <div style={{ fontSize: '13px', marginTop: '5px' }}>
                                    {(luongCoBan?.dsIdBaoHiemThang?.length ?? 0) > 0
                                        ? `${luongCoBan?.dsIdBaoHiemThang?.length} kỳ`
                                        : 'Không có'}
                                </div>
                            </Col>
                            <Col xs={24} sm={12} md={luongCoBan?.loai === 1 ? 8 : 6}>
                                <div style={{ fontSize: '12px', color: '#666' }}>Tăng/Giảm áp dụng</div>
                                <div style={{ fontSize: '13px', marginTop: '5px' }}>
                                    {(luongCoBan?.dsIdLuongKhenThuongUngHo?.length ?? 0) > 0
                                        ? `${luongCoBan?.dsIdLuongKhenThuongUngHo?.length} khoản`
                                        : 'Không có'}
                                </div>
                            </Col>
                            <Col xs={24} sm={12} md={luongCoBan?.loai === 1 ? 8 : 6}>
                                <div style={{ fontSize: '12px', color: '#666' }}>Trừ kinh phí công đoàn</div>
                                <div style={{ fontSize: '13px', marginTop: '5px' }}>
                                    {luongCoBan?.isTruCongDoan ? 'Có' : 'Không'}
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>

            <Row gutter={8} className="form-group">
                <Col xs={24} sm={8} md={luongCoBan?.loai === 0 ? 4 : 6}>
                    <div className="card card-primary" style={{ padding: '10px' }}>
                        <div className="text-center" style={{ fontSize: '12px' }}>Tổng mức lương HĐ</div>
                        <div className="text-bold text-center">{formatVND(tongMucLuong)}</div>
                    </div>
                </Col>
                <Col xs={24} sm={8} md={luongCoBan?.loai === 0 ? 4 : 6}>
                    <div className="card card-primary" style={{ padding: '10px' }}>
                        <div className="text-center" style={{ fontSize: '12px' }}>Tổng tiền tạm ứng</div>
                        <div className="text-bold text-center">{formatVND(tongTienTamUng)}</div>
                    </div>
                </Col>
                {luongCoBan?.loai === 0 && (
                    <Col xs={24} sm={8} md={4}>
                        <div className="card card-primary" style={{ padding: '10px' }}>
                            <div className="text-center" style={{ fontSize: '12px' }}>Tổng lương đã nhận</div>
                            <div className="text-bold text-center">{formatVND(tongLuongDaNhan)}</div>
                        </div>
                    </Col>
                )}
                <Col xs={24} sm={8} md={luongCoBan?.loai === 0 ? 4 : 6}>
                    <div className="card card-primary" style={{ padding: '10px' }}>
                        <div className="text-center" style={{ fontSize: '12px' }}>Tổng CB thực nhận</div>
                        <div className="text-bold text-center">{formatVND(tongThucNhan)}</div>
                    </div>
                </Col>
                <Col xs={24} sm={24} md={luongCoBan?.loai === 0 ? 8 : 6}>
                    <div className="card card-primary" style={{ padding: '10px' }}>
                        <div className="text-center" style={{ fontSize: '12px' }}>Trạng thái</div>
                        <div className="text-bold text-center">
                            {isDaDuyet ? (
                                <span style={{ color: '#52c41a' }}>Đã xác nhận</span>
                            ) : (
                                <span style={{ color: '#faad14' }}>Chưa xác nhận</span>
                            )}
                        </div>
                    </div>
                </Col>
            </Row>

            <Row gutter={8} className="form-group">
                <Col span={24}>
                    <div className="card card-primary" style={{ padding: '15px' }}>
                        <div style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '10px' }}>Ghi chú</div>
                        {!isDaDuyet ? (
                            <Input.TextArea
                                rows={3}
                                placeholder="Nhập ghi chú..."
                                value={ghiChu}
                                onChange={(e) => setGhiChu(e.target.value)}
                            />
                        ) : (
                            <div style={{ whiteSpace: 'pre-wrap', minHeight: '40px', background: '#f5f5f5', padding: '10px', borderRadius: '4px' }}>
                                {ghiChu || 'Không có ghi chú'}
                            </div>
                        )}
                    </div>
                </Col>
            </Row>

            <Row>
                <Col span={24}>
                    <div className="card-outline">
                        <Tabs
                            tabBarExtraContent={
                                <>
                                    <Space>
                                        {coTheDieuChinh && (
                                            <Button
                                                style={{ width: '140px' }}
                                                type="default"
                                                onClick={() => {
                                                    if (isEdit) {
                                                        // Khi khóa, reload lại dữ liệu nếu có thay đổi chưa lưu
                                                        if (changedRowIds.size > 0) {
                                                            layThongTin(idLuongCoBan);
                                                            setChangedRowIds(new Set());
                                                        }
                                                    }
                                                    setIsEdit(!isEdit);
                                                }}
                                                icon={isEdit ? <LockOutlined style={{ color: 'red' }} /> : <EditOutlined style={{ color: '#007bff' }} />}
                                            >{isEdit ? 'Khóa' : 'Điều chỉnh'}
                                            </Button>
                                        )}
                                        {isEdit && changedRowIds.size > 0 && (
                                            <Button
                                                className="hrm-btn hrm-btn-warning"
                                                icon={<SaveOutlined />}
                                                onClick={handleLuuDieuChinh}
                                            >
                                                Lưu điều chỉnh ({changedRowIds.size})
                                            </Button>
                                        )}
                                    </Space>
                                </>
                            }
                            defaultActiveKey="1"
                            items={[
                                {
                                    key: '1',
                                    label: luongCoBan?.loai === 0 ? 'Bảng lương điều chỉnh' : 'Bảng lương tạm ứng',
                                    children: (
                                        <TableChiTietLuongCoBan
                                            dataSource={danhSachNLD}
                                            loading={loading}
                                            dynamicColumns={luongCoBan?.dynamicColumnHeaders}
                                            isDieuChinh={luongCoBan?.loai === 0}
                                            isEdit={isEdit}
                                            onChangeItem={onChangeItem}
                                        />
                                    ),
                                },
                            ]}
                        />
                    </div>
                </Col>
            </Row>

            <ModalTextForm
                show={isShowModalDuyet}
                title="Xác nhận lương cơ bản"
                handleClose={() => setIsShowModalDuyet(false)}
                handleSave={handleDuyet}
            >
                Bạn có chắc muốn xác nhận lương cơ bản tháng{' '}
                {dateCommon.formatDate(luongCoBan?.thangNam, 'MM/yyyy')} không?
            </ModalTextForm>

            {isShowModalCapNhatThamChieu && (
                <ModalTextForm
                    title="Cập nhật dữ liệu tham chiếu"
                    hideFooter
                    show={isShowModalCapNhatThamChieu}
                    handleClose={() => setIsShowModalCapNhatThamChieu(false)}
                >
                    <Form
                        layout="vertical"
                        validateMessages={validateMessages}
                        onFinish={onFinishCapNhatThamChieu}
                        form={form}
                    >
                        <Row gutter={8}>
                            <Col span={8}>
                                <Form.Item label="Năm bảo hiểm">
                                    <DatePicker
                                        changeOnBlur={true}
                                        picker="year"
                                        placeholder="Năm (để trống = tất cả)"
                                        style={{ width: "100%" }}
                                        value={namLocBaoHiem}
                                        onChange={onChangeNamLocBaoHiem}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={16}>
                                <Form.Item label="Bảo hiểm áp dụng" name="dsIdBaoHiemThang">
                                    <Select
                                        mode="multiple"
                                        allowClear
                                        placeholder="Chọn các kỳ bảo hiểm"
                                        options={(dsBaoHiem || []).map((x: any) => ({
                                            value: x.id,
                                            label: `Tháng ${dayjs(x.thangNam).format('MM/YYYY')}${x.loaiBaoHiemThang === 1 ? ' - Bổ sung/Điều chỉnh' : ''}`,
                                        }))}
                                        notFoundContent="Không có dữ liệu"
                                        filterOption={(input, option: any) =>
                                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                        }
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={8}>
                            <Col span={8}>
                                <Form.Item label="Năm tăng/giảm">
                                    <DatePicker
                                        changeOnBlur={true}
                                        picker="year"
                                        placeholder="Năm (để trống = tất cả)"
                                        style={{ width: "100%" }}
                                        value={namLocKhenThuong}
                                        onChange={onChangeNamLocKhenThuong}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={16}>
                                <Form.Item label="Tăng/Giảm áp dụng" name="dsIdLuongKhenThuongUngHo">
                                    <Select
                                        mode="multiple"
                                        allowClear
                                        placeholder="Chọn các kỳ tăng/giảm"
                                        options={(dsKhenThuongUngHo || []).map((x) => ({
                                            value: x.id,
                                            label: `${x.ten} (${x.thoiGian})`,
                                        }))}
                                        notFoundContent="Không có dữ liệu"
                                        filterOption={(input, option: any) =>
                                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                        }
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        {luongCoBan?.loai === 0 && (
                            <Row gutter={8}>
                                <Col span={8}>
                                    <Form.Item label="Năm tạm ứng">
                                        <DatePicker
                                            changeOnBlur={true}
                                            picker="year"
                                            placeholder="Năm (để trống = tất cả)"
                                            style={{ width: "100%" }}
                                            value={namLocTamUng}
                                            onChange={onChangeNamLocTamUng}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={16}>
                                    <Form.Item
                                        rules={[{ required: true, message: 'Vui lòng chọn bảng lương tạm ứng!' }]}
                                        label="Bảng lương tạm ứng khấu trừ"
                                        name="idLuongTamUng"
                                    >
                                        <Select
                                            placeholder="Chọn bảng lương tạm ứng"
                                            options={(dsTamUng || []).map((x) => ({
                                                value: x.id,
                                                label: `${x.tenKyLuong} (Ngày tạo: ${dateCommon.formatDate(x.ngayKhoiTao)})`,
                                            }))}
                                            allowClear
                                            notFoundContent="Không có dữ liệu bảng lương tạm ứng"
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                        )}
                        <Form.Item name="isTruCongDoan" valuePropName="checked">
                            <Checkbox>Trừ kinh phí công đoàn</Checkbox>
                        </Form.Item>
                        <Form.Item>
                            <Button
                                type="primary"
                                className="float-right"
                                htmlType="submit"
                                icon={<SaveOutlined />}
                            >
                                Cập nhật
                            </Button>
                        </Form.Item>
                    </Form>
                </ModalTextForm>
            )}

            <ModalTextForm
                show={isShowModalXoa}
                title="Xóa bảng lương cơ bản"
                handleClose={() => setIsShowModalXoa(false)}
                handleSave={handleXoa}
            >
                Bạn có chắc chắn muốn xóa bảng lương cơ bản <b>{luongCoBan?.tenKyLuong ?? ''}</b>? Hành động này sẽ xóa toàn bộ dữ liệu chi tiết của bảng lương.
            </ModalTextForm>

            <Modal
                title="Import dữ liệu lương cơ bản từ Excel"
                open={isShowImportModal}
                onCancel={() => {
                    setIsShowImportModal(false);
                    setFileUpload(null);
                }}
                footer={[
                    <Button
                        key="cancel"
                        onClick={() => {
                            setIsShowImportModal(false);
                            setFileUpload(null);
                        }}
                    >
                        Hủy
                    </Button>,
                    <Button
                        key="submit"
                        type="primary"
                        disabled={!fileUpload}
                        icon={<UploadOutlined />}
                        onClick={() => handleImportExcel(false)}
                    >
                        Tải lên
                    </Button>,
                ]}
                destroyOnClose
                centered
            >
                <div style={{ padding: '8px 0' }}>
                    <Dropzone
                        maxFiles={1}
                        multiple={false}
                        accept={{
                            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
                            'application/vnd.ms-excel': ['.xls'],
                        }}
                        onDrop={(acceptedFiles) => {
                            if (acceptedFiles && acceptedFiles.length > 0) {
                                setFileUpload(acceptedFiles[0]);
                            }
                        }}
                    >
                        {({ getRootProps, getInputProps, isDragActive }) => (
                            <div
                                {...getRootProps()}
                                className="hrm-dropzone-uploadfile"
                                style={{
                                    padding: '28px 16px',
                                    background: isDragActive ? '#e6f4ff' : '#fafafa',
                                    borderColor: isDragActive ? '#1677ff' : fileUpload ? '#28a745' : '#d9d9d9',
                                    borderWidth: 1,
                                    borderStyle: 'dashed',
                                    borderRadius: 8,
                                    textAlign: 'center',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease',
                                }}
                            >
                                <input {...getInputProps()} />
                                {isDragActive ? (
                                    <div>
                                        <p style={{ marginBottom: 8 }}>
                                            <InboxOutlined style={{ color: '#1677ff', fontSize: 42 }} />
                                        </p>
                                        <p style={{ fontSize: 14, fontWeight: 500, color: '#1677ff', margin: 0 }}>
                                            Thả tệp Excel vào đây...
                                        </p>
                                    </div>
                                ) : fileUpload ? (
                                    <div>
                                        <p style={{ marginBottom: 8 }}>
                                            <FileExcelOutlined style={{ color: '#217346', fontSize: 40 }} />
                                        </p>
                                        <p style={{ fontSize: 14, fontWeight: 600, color: '#262626', margin: '0 0 4px 0', wordBreak: 'break-all' }}>
                                            {fileUpload.name}
                                        </p>
                                        <p style={{ fontSize: 12, color: '#8c8c8c', margin: '0 0 8px 0' }}>
                                            Kích thước: {(fileUpload.size / 1024).toFixed(1)} KB
                                        </p>
                                        <Button
                                            size="small"
                                            danger
                                            icon={<DeleteOutlined />}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setFileUpload(null);
                                            }}
                                        >
                                            Chọn tệp khác
                                        </Button>
                                    </div>
                                ) : (
                                    <div>
                                        <p style={{ marginBottom: 8 }}>
                                            <InboxOutlined style={{ color: '#1677ff', fontSize: 42 }} />
                                        </p>
                                        <p style={{ fontSize: 14, fontWeight: 500, color: '#262626', margin: '0 0 4px 0' }}>
                                            Nhấp hoặc kéo thả tệp Excel vào đây để tải lên
                                        </p>
                                        <p style={{ fontSize: 12, color: '#8c8c8c', margin: 0 }}>
                                            Hỗ trợ định dạng tệp .xlsx, .xls
                                        </p>
                                    </div>
                                )}
                            </div>
                        )}
                    </Dropzone>
                </div>
            </Modal>

            <Modal
                title="Các dữ liệu danh mục bậc, hệ số lương còn thiếu"
                open={isShowModalThieuDanhMuc}
                width={850}
                onCancel={() => {
                    setIsShowModalThieuDanhMuc(false);
                    setDsDanhMucThieu([]);
                }}
                footer={[
                    <Button
                        key="cancel"
                        onClick={() => {
                            setIsShowModalThieuDanhMuc(false);
                            setDsDanhMucThieu([]);
                        }}
                    >
                        Hủy
                    </Button>,
                    <Button
                        key="confirm"
                        type="primary"
                        onClick={() => handleImportExcel(true)}
                    >
                        Đồng ý
                    </Button>,
                ]}
                destroyOnClose
                centered
            >
                <div style={{ marginBottom: 12, color: '#d46b08', fontWeight: 500 }}>
                    Phát hiện các thông tin Bậc lương, Hệ số lương và Mức lương đóng BHXH trong file Excel chưa có trong cơ sở dữ liệu.
                    Nhấn <b>Đồng ý</b> để hệ thống tự động bổ sung các danh mục còn thiếu và xác nhận import dữ liệu lương cơ bản:
                </div>
                <Table
                    bordered
                    size="small"
                    pagination={false}
                    rowKey={(_r, idx) => `missing-hsl-${idx}`}
                    dataSource={dsDanhMucThieu}
                    scroll={{ y: 360 }}
                    columns={[
                        {
                            title: 'STT',
                            width: 55,
                            align: 'center',
                            render: (_v, _r, idx) => idx + 1,
                        },
                        {
                            title: 'Ngạch / Bậc lương',
                            dataIndex: 'tenBacLuong',
                            width: 150,
                        },
                        {
                            title: 'Chức vụ',
                            dataIndex: 'tenChucVu',
                            width: 140,
                        },
                        {
                            title: 'Bậc',
                            dataIndex: 'bac',
                            width: 90,
                            align: 'center',
                        },
                        {
                            title: 'Hệ số lương',
                            dataIndex: 'heSo',
                            width: 100,
                            align: 'right',
                        },
                        {
                            title: 'Mức lương đóng BHXH',
                            dataIndex: 'mucLuong',
                            width: 150,
                            align: 'right',
                            render: (v: number) => formatVND(v ?? 0),
                        },
                        {
                            title: 'Nhân sự',
                            dataIndex: 'danhSachNhanVien',
                        },
                    ]}
                />
            </Modal>
        </section>
    );
};

export default ChiTietLuongCoBan;
